export const STORAGE_KEY = 'jwt_access_token';

export const BRANCHES_SHORT = 'branches_short_key';

export const ACCESS_LEVEL = 'access_level_key';

export const MENUS = 'menus_key';

export const MAIN_MENU = 'main_menu_key';

export const SUB_MENU = 'sub_menu_key';

export const path = 'path_name_key';
